var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgConfirmationImage = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 560,
    height: 528,
    viewBox: "0 0 560 528",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_393_551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M528.249 229.127C528.249 229.127 451.998 42.9755 312.603 7.02343C173.208 -28.9286 114.745 80.9904 93.3829 157.235C72.0208 233.479 -6.69586 334.408 0.452616 403.736C7.24367 469.63 64.9438 500.789 118.831 514.168C187.326 531.16 265.161 532.448 333.905 518.282C350.264 514.907 366.312 510.388 382.241 505.189C414.54 494.647 446.244 486.479 478.972 477.739C541.211 461.116 565.874 394.208 558.856 330.186C554.901 294.163 541.712 261.919 528.261 229.127H528.249Z",
    fill: "#D0E9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5869 241.731L56.5685 452.483",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0298 412.143L43.0696 401.613",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0958 404.773C46.0958 404.773 46.3817 400.111 42.1284 396.319C39.5668 394.029 26.1158 388.365 24.841 393.111C23.447 398.275 37.2317 408.398 46.0958 404.773Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.096 404.773L33.2764 396.784",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.52 436.111L45.5598 425.581",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.586 428.741C48.586 428.741 48.872 424.079 44.6186 420.287C42.0571 417.997 28.606 412.333 27.3312 417.079C25.9373 422.243 39.7219 432.366 48.586 428.741Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.586 428.741L35.7783 420.752",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9299 353.665L36.9697 343.136",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9959 346.284C39.9959 346.284 40.2819 341.622 36.0285 337.83C33.467 335.54 20.0159 329.876 18.7411 334.622C17.3472 339.785 31.1318 349.909 39.9959 346.284Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9959 346.284L27.1763 338.295",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4318 377.633L39.4597 367.104",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4859 370.252C42.4859 370.252 42.7719 365.59 38.5185 361.798C35.957 359.508 22.5059 353.844 21.2311 358.59C19.8372 363.753 33.6218 373.877 42.4859 370.252Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4859 370.252L29.6782 362.263",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8672 314.732L32.907 304.203",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9332 307.351C35.9332 307.351 36.2191 302.689 31.9658 298.897C29.4042 296.607 15.9532 290.943 14.6784 295.689C13.2844 300.852 27.0691 310.976 35.9332 307.351Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9332 307.351L23.1255 299.362",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7925 275.62L28.8323 265.091",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8585 268.251C31.8585 268.251 32.1444 263.589 27.8911 259.797C25.3295 257.507 11.8785 251.843 10.6037 256.589C9.20971 261.752 22.9944 271.876 31.8585 268.251Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8584 268.251L19.0388 260.262",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3501 397.965L58.9275 385.599",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6162 389.319C56.6162 389.319 55.3771 384.824 58.7488 380.221C60.7742 377.455 72.7836 369.131 75.0116 373.508C77.4301 378.265 66.0522 391.025 56.6162 389.319Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.616 389.319L68.1488 378.277",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7734 334.896L52.3508 322.531",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0395 326.251C50.0395 326.251 48.8004 321.756 52.1721 317.153C54.1975 314.386 66.207 306.063 68.4349 310.44C70.8535 315.197 59.4755 327.956 50.0395 326.251Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0396 326.251L61.5724 315.209",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8901 307.172L49.4556 294.819",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1442 298.527C47.1442 298.527 45.9052 294.032 49.2769 289.429C51.3023 286.662 63.3117 278.339 65.5397 282.715C67.9582 287.473 56.5802 300.232 47.1442 298.527Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1443 298.527L58.6891 287.497",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6487 266.546L45.2261 254.18",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9147 257.889C42.9147 257.889 41.6757 253.393 45.0474 248.79C47.0728 246.024 59.0822 237.701 61.3102 242.077C63.7287 246.835 52.3507 259.594 42.9147 257.889Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9148 257.889L54.4477 246.859",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4082 240.563C34.4082 240.563 33.1691 236.067 36.5408 231.464C38.5662 228.698 50.5756 220.375 52.8036 224.751C55.2221 229.509 43.8441 242.268 34.4082 240.563Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4082 240.563L45.9411 229.533",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0754 241.04C35.0754 241.04 30.4765 241.803 26.2589 237.963C23.7212 235.65 16.7157 222.831 21.2907 221.078C26.2708 219.17 37.7561 231.834 35.0635 241.04H35.0754Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0753 241.04L25.3176 228.4",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.549 270.755L70.6985 481.519",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5356 441.322L67.9463 428.956",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2578 432.676C70.2578 432.676 71.4968 428.181 68.1132 423.578C66.0759 420.812 54.0784 412.5 51.8504 416.877C49.4319 421.634 60.8218 434.394 70.2459 432.676H70.2578Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2577 432.676L59.3682 422.207",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6 382.832L74.0107 370.467",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.322 374.187C76.322 374.187 77.561 369.692 74.1774 365.089C72.1401 362.323 60.1426 354.011 57.9146 358.387C55.4961 363.145 66.886 375.904 76.3101 374.187H76.322Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3221 374.187L65.4326 363.718",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1099 406.801L71.5325 394.435",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.844 398.155C73.844 398.155 75.083 393.66 71.6994 389.057C69.6621 386.291 57.6646 377.979 55.4366 382.356C53.018 387.113 64.408 399.872 73.832 398.155H73.844Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8439 398.155L62.9543 387.698",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6389 343.887L78.0496 331.534",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.361 335.242C80.361 335.242 81.6001 330.747 78.2165 326.144C76.1792 323.378 64.1816 315.066 61.9537 319.442C59.5351 324.2 70.925 336.959 80.3491 335.242H80.361Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3609 335.242L69.4714 324.785",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6896 304.787L82.1003 292.434",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4235 296.142C84.4235 296.142 85.6626 291.647 82.279 287.044C80.2417 284.277 68.2441 275.966 66.0162 280.342C63.5976 285.1 74.9875 297.859 84.4116 296.142H84.4235Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4237 296.142L73.5222 285.685",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8105 427.096L86.7708 416.555",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7446 419.715C83.7446 419.715 83.4586 415.052 87.7001 411.26C90.2616 408.971 103.713 403.295 104.987 408.041C106.381 413.204 92.6087 423.34 83.7327 419.715H83.7446Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7446 419.715L97.3029 411.296",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3513 364.016L93.3115 353.487",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2854 356.647C90.2854 356.647 89.9994 351.984 94.2408 348.192C96.8024 345.903 110.253 340.227 111.528 344.973C112.922 350.136 99.1495 360.272 90.2734 356.647H90.2854Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2854 356.647L103.844 348.216",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2227 336.304L96.1829 325.762",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1567 328.922C93.1567 328.922 92.8708 324.26 97.1122 320.468C99.6737 318.178 113.125 312.502 114.4 317.248C115.794 322.412 102.021 332.547 93.1448 328.922H93.1567Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1567 328.922L106.715 320.504",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4402 295.665L100.388 285.124",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3742 288.284C97.3742 288.284 97.0883 283.622 101.33 279.83C103.891 277.54 117.342 271.864 118.617 276.61C120.011 281.773 106.238 291.909 97.3623 288.284H97.3742Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3743 288.284L110.933 279.865",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6086 269.575C92.6086 269.575 92.3227 264.912 96.5641 261.12C99.1256 258.831 112.577 253.155 113.851 257.901C115.245 263.064 101.473 273.2 92.5967 269.575H92.6086Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6086 269.575L106.167 261.156",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1687 270.183C93.1687 270.183 88.5103 269.98 85.1743 265.353C83.1728 262.575 78.9433 248.588 83.7923 247.801C89.0584 246.954 97.6961 261.728 93.1687 270.171V270.183Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1686 270.183L86.2227 255.802",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5176 184.935V451.457",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.72 411.379L58.9036 399.872",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5962 403.319C61.5962 403.319 62.3587 398.716 58.5343 394.495C56.2229 391.955 43.4272 384.919 41.6639 389.51C39.7457 394.495 52.3985 406.002 61.5962 403.319Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5963 403.319L49.6821 394.041",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.72 361.297L58.9036 349.79",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5962 353.236C61.5962 353.236 62.3587 348.633 58.5343 344.412C56.2229 341.872 43.4272 334.837 41.6639 339.428C39.7457 344.412 52.3985 355.919 61.5962 353.236Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5963 353.236L49.6821 343.959",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.72 302.486L58.9036 290.979",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5962 294.437C61.5962 294.437 62.3587 289.834 58.5343 285.613C56.2229 283.073 43.4272 276.038 41.6639 280.629C39.7457 285.613 52.3985 297.12 61.5962 294.437Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5963 294.437L49.6821 285.16",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.72 263.35L58.9036 251.831",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5962 255.289C61.5962 255.289 62.3587 250.686 58.5343 246.465C56.2229 243.925 43.4272 236.89 41.6639 241.481C39.7457 246.465 52.3985 257.972 61.5962 255.289Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5963 255.289L49.6821 246.012",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.72 224.035L58.9036 212.516",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5962 215.975C61.5962 215.975 62.3587 211.372 58.5343 207.15C56.2229 204.611 43.4272 197.575 41.6639 202.166C39.7457 207.15 52.3985 218.657 61.5962 215.975Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5963 215.975L49.6821 206.697",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5293 426.678L76.3458 415.16",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6652 418.618C73.6652 418.618 72.9027 414.015 76.7272 409.794C79.0385 407.254 91.8343 400.218 93.5976 404.809C95.5158 409.794 82.863 421.301 73.6652 418.618Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6653 418.618L86.2823 408.84",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5293 347.012L76.3458 335.505",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6652 338.963C73.6652 338.963 72.9027 334.36 76.7272 330.139C79.0385 327.599 91.8343 320.563 93.5976 325.154C95.5158 330.139 82.863 341.646 73.6652 338.963Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6653 338.963L86.2823 329.185",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5293 307.697L76.3458 296.19",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6652 299.648C73.6652 299.648 72.9027 295.045 76.7272 290.824C79.0385 288.284 91.8343 281.249 93.5976 285.84C95.5158 290.824 82.863 302.331 73.6652 299.648Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6653 299.648L86.2823 289.87",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5293 255.73L76.3458 244.223",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6652 247.681C73.6652 247.681 72.9027 243.079 76.7272 238.857C79.0385 236.318 91.8343 229.282 93.5976 233.873C95.5158 238.857 82.863 250.364 73.6652 247.681Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6653 247.681L86.2823 237.903",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5293 214.877L76.3458 203.37",
    stroke: "#263238",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6652 206.829C73.6652 206.829 72.9027 202.226 76.7272 198.004C79.0385 195.465 91.8343 188.429 93.5976 193.02C95.5158 198.004 82.863 209.512 73.6652 206.829Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6653 206.829L86.2823 197.051",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0051 188.703C67.0051 188.703 66.2426 184.101 70.067 179.879C72.3784 177.34 85.1741 170.304 86.9374 174.895C88.8556 179.879 76.2028 191.386 67.0051 188.703Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0051 188.703L79.6222 178.925",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6127 189.252C67.6127 189.252 62.9543 189.538 59.1656 185.269C56.89 182.705 51.2427 169.231 55.9845 167.955C61.1433 166.572 71.2465 180.368 67.6127 189.24V189.252Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6129 189.252L59.2253 175.658",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4666 520.571H50.2658L46.7393 449.287H81.9932L78.4666 520.571Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.575 354.655C428.575 354.655 428.73 350.756 430.374 348.049C432.018 345.354 438.023 343.398 441.168 344.746C444.314 346.093 445.815 347 445.815 347C445.815 347 441.168 348.347 436.975 351.197C432.781 354.047 428.575 354.643 428.575 354.643V354.655Z",
    fill: "#0088FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.285 356.611C422.285 356.611 425.883 353.165 426.478 348.359C427.074 343.554 421.987 350.362 421.987 350.362C421.987 350.362 419.437 340.704 417.936 346.105C416.435 351.507 422.285 356.611 422.285 356.611Z",
    fill: "#0088FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.386 355.108C415.386 355.108 416.28 350.613 414.636 347.453C412.992 344.305 408.643 344.603 404.294 345.95C399.946 347.298 398.599 347.298 398.599 347.298C398.599 347.298 403.699 350.744 408.047 352.545C412.396 354.345 415.386 355.096 415.386 355.096V355.108Z",
    fill: "#0088FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.237 371.278C422.451 371.278 422.63 371.099 422.63 370.884V349.432C422.63 349.218 422.451 349.039 422.237 349.039C422.022 349.039 421.844 349.218 421.844 349.432V370.884C421.844 371.099 422.022 371.278 422.237 371.278Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.438 371.278C420.438 371.278 420.474 371.278 420.497 371.278C420.712 371.254 420.855 371.051 420.831 370.837C420.76 370.3 418.949 357.589 412.801 350.529C412.658 350.362 412.42 350.35 412.253 350.494C412.086 350.637 412.074 350.875 412.217 351.042C418.21 357.922 420.057 370.813 420.069 370.944C420.092 371.135 420.259 371.278 420.45 371.278H420.438Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.036 370.98C424.25 370.98 424.417 370.801 424.417 370.586C424.417 370.467 424.358 358.256 431.613 352.437C431.78 352.306 431.804 352.056 431.673 351.889C431.542 351.722 431.292 351.698 431.125 351.829C423.571 357.875 423.631 370.073 423.631 370.586C423.631 370.801 423.81 370.968 424.024 370.968L424.036 370.98Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.043 370.825C418.043 370.825 418.115 370.825 418.138 370.813C418.341 370.753 418.472 370.538 418.412 370.336C418.365 370.169 417.316 366.329 414.91 363.002C414.779 362.823 414.54 362.788 414.374 362.919C414.195 363.05 414.159 363.288 414.29 363.455C416.613 366.663 417.662 370.491 417.674 370.527C417.721 370.705 417.876 370.813 418.043 370.813V370.825Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.684 364.862C415.684 364.862 415.839 360.665 414.04 360.057C412.241 359.449 410.597 360.951 409.239 361.857C407.892 362.752 406.391 363.658 406.391 366.353C406.391 369.048 407.44 374.008 407.44 374.008C407.44 374.008 408.941 369.358 411.49 367.259C414.04 365.161 415.684 364.862 415.684 364.862Z",
    fill: "#0088FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.74 370.98C426.907 370.98 427.062 370.872 427.11 370.705C427.11 370.67 428.313 367.033 431.03 364.886C431.196 364.755 431.232 364.505 431.089 364.338C430.958 364.171 430.708 364.147 430.541 364.278C427.634 366.58 426.419 370.312 426.359 370.467C426.3 370.67 426.407 370.884 426.609 370.956C426.645 370.968 426.693 370.98 426.729 370.98H426.74Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.575 366.21C428.575 366.21 427.979 363.515 429.469 361.559C430.97 359.604 434.568 360.057 436.367 362.156C438.166 364.254 440.716 370.562 440.716 370.562C440.716 370.562 437.118 367.712 432.924 367.712C428.73 367.712 428.575 366.21 428.575 366.21Z",
    fill: "#0088FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.637 393.97H428.599L434.58 374.175H410.656L416.637 393.97Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.585 374.175H434.64V370.896H410.585V374.175Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M432.066 311.811C431.256 311.548 431.006 310.94 431.232 310.296L431.292 310.129C431.554 309.45 432.102 309.223 432.841 309.45C433.555 309.712 434.711 310.296 435.581 310.905C435.295 309.903 435.069 308.544 435.069 307.733C435.069 306.993 435.485 306.469 436.236 306.469H436.403C437.142 306.469 437.57 306.981 437.57 307.733C437.57 308.544 437.344 309.903 437.058 310.905C437.964 310.284 439.095 309.712 439.81 309.45C440.525 309.223 441.133 309.45 441.359 310.165L441.395 310.261C441.621 311 441.395 311.548 440.585 311.811C439.846 312.037 438.583 312.228 437.511 312.264C438.321 312.884 439.322 313.778 439.81 314.434C440.227 315.018 440.168 315.698 439.62 316.116L439.489 316.211C438.869 316.664 438.261 316.533 437.773 315.889C437.32 315.245 436.772 314.172 436.355 313.075C435.902 314.172 435.354 315.245 434.902 315.889C434.413 316.533 433.806 316.664 433.186 316.211L433.055 316.116C432.471 315.698 432.435 315.018 432.864 314.434C433.353 313.79 434.354 312.884 435.164 312.24C434.127 312.24 432.841 312.049 432.09 311.823L432.066 311.811Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.147 311.811C443.337 311.548 443.087 310.94 443.313 310.296L443.373 310.129C443.635 309.45 444.183 309.223 444.921 309.45C445.636 309.712 446.792 310.296 447.662 310.905C447.376 309.903 447.149 308.544 447.149 307.733C447.149 306.993 447.566 306.469 448.317 306.469H448.484C449.222 306.469 449.651 306.981 449.651 307.733C449.651 308.544 449.425 309.903 449.139 310.905C450.044 310.284 451.176 309.712 451.891 309.45C452.606 309.223 453.214 309.45 453.44 310.165L453.476 310.261C453.702 311 453.476 311.548 452.666 311.811C451.927 312.037 450.664 312.228 449.592 312.264C450.402 312.884 451.403 313.778 451.891 314.434C452.308 315.018 452.249 315.698 451.701 316.116L451.569 316.211C450.95 316.664 450.342 316.533 449.854 315.889C449.401 315.245 448.853 314.172 448.436 313.075C447.983 314.172 447.435 315.245 446.983 315.889C446.494 316.533 445.886 316.664 445.267 316.211L445.136 316.116C444.552 315.698 444.516 315.018 444.945 314.434C445.434 313.79 446.434 312.884 447.245 312.24C446.208 312.24 444.921 312.049 444.171 311.823L444.147 311.811Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.228 311.811C455.418 311.548 455.168 310.94 455.394 310.296L455.454 310.129C455.716 309.45 456.264 309.223 457.002 309.45C457.717 309.712 458.873 310.296 459.755 310.905C459.469 309.903 459.242 308.544 459.242 307.733C459.242 306.993 459.659 306.469 460.41 306.469H460.577C461.315 306.469 461.744 306.981 461.744 307.733C461.744 308.544 461.518 309.903 461.232 310.905C462.137 310.284 463.269 309.712 463.984 309.45C464.699 309.223 465.307 309.45 465.533 310.165L465.569 310.261C465.795 311 465.569 311.548 464.759 311.811C464.02 312.037 462.757 312.228 461.685 312.264C462.495 312.884 463.496 313.778 463.984 314.434C464.401 315.018 464.342 315.698 463.793 316.116L463.662 316.211C463.043 316.664 462.435 316.533 461.947 315.889C461.494 315.245 460.946 314.172 460.529 313.075C460.076 314.172 459.528 315.245 459.075 315.889C458.587 316.533 457.979 316.664 457.36 316.211L457.229 316.116C456.645 315.698 456.609 315.018 457.038 314.434C457.527 313.79 458.527 312.884 459.338 312.24C458.301 312.24 457.014 312.049 456.264 311.823L456.228 311.811Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.309 311.811C467.499 311.548 467.248 310.94 467.475 310.296L467.534 310.129C467.797 309.45 468.345 309.223 469.083 309.45C469.798 309.712 470.954 310.296 471.823 310.905C471.538 309.903 471.311 308.544 471.311 307.733C471.311 306.993 471.728 306.469 472.479 306.469H472.646C473.384 306.469 473.813 306.981 473.813 307.733C473.813 308.544 473.587 309.903 473.301 310.905C474.206 310.284 475.338 309.712 476.053 309.45C476.768 309.223 477.375 309.45 477.602 310.165L477.638 310.261C477.864 311 477.638 311.548 476.827 311.811C476.089 312.037 474.826 312.228 473.754 312.264C474.564 312.884 475.565 313.778 476.053 314.434C476.47 315.018 476.41 315.698 475.862 316.116L475.731 316.211C475.112 316.664 474.504 316.533 474.016 315.889C473.563 315.245 473.015 314.172 472.598 313.075C472.145 314.172 471.597 315.245 471.144 315.889C470.656 316.533 470.048 316.664 469.429 316.211L469.298 316.116C468.714 315.698 468.678 315.018 469.107 314.434C469.596 313.79 470.596 312.884 471.407 312.24C470.37 312.24 469.083 312.049 468.333 311.823L468.309 311.811Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.39 311.811C479.58 311.548 479.33 310.94 479.556 310.296L479.615 310.129C479.878 309.45 480.426 309.223 481.164 309.45C481.879 309.712 483.035 310.296 483.905 310.905C483.619 309.903 483.392 308.544 483.392 307.733C483.392 306.993 483.809 306.469 484.56 306.469H484.727C485.465 306.469 485.894 306.981 485.894 307.733C485.894 308.544 485.668 309.903 485.382 310.905C486.287 310.284 487.419 309.712 488.122 309.45C488.837 309.223 489.445 309.45 489.671 310.165L489.707 310.261C489.933 311 489.707 311.548 488.897 311.811C488.158 312.037 486.895 312.228 485.823 312.264C486.633 312.884 487.634 313.778 488.122 314.434C488.539 315.018 488.48 315.698 487.932 316.116L487.8 316.211C487.181 316.664 486.573 316.533 486.085 315.889C485.632 315.245 485.084 314.172 484.667 313.075C484.214 314.172 483.666 315.245 483.213 315.889C482.725 316.533 482.117 316.664 481.498 316.211L481.367 316.116C480.783 315.698 480.747 315.018 481.176 314.434C481.665 313.79 482.665 312.884 483.476 312.24C482.439 312.24 481.152 312.049 480.402 311.823L480.39 311.811Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.471 311.811C491.661 311.548 491.41 310.94 491.625 310.296L491.684 310.129C491.947 309.45 492.495 309.223 493.233 309.45C493.948 309.712 495.104 310.296 495.974 310.905C495.688 309.903 495.461 308.544 495.461 307.733C495.461 306.993 495.878 306.469 496.629 306.469H496.796C497.534 306.469 497.963 306.981 497.963 307.733C497.963 308.544 497.737 309.903 497.451 310.905C498.356 310.284 499.488 309.712 500.191 309.45C500.906 309.223 501.514 309.45 501.74 310.165L501.776 310.261C502.002 311 501.776 311.548 500.966 311.811C500.227 312.037 498.964 312.228 497.892 312.264C498.702 312.884 499.703 313.778 500.179 314.434C500.596 315.018 500.537 315.698 499.989 316.116L499.857 316.211C499.238 316.664 498.63 316.533 498.142 315.889C497.689 315.245 497.141 314.172 496.724 313.075C496.271 314.172 495.723 315.245 495.271 315.889C494.782 316.533 494.174 316.664 493.555 316.211L493.424 316.116C492.84 315.698 492.804 315.018 493.233 314.434C493.722 313.79 494.723 312.884 495.533 312.24C494.496 312.24 493.209 312.049 492.459 311.823L492.471 311.811Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.552 311.811C503.741 311.548 503.491 310.94 503.706 310.296L503.765 310.129C504.027 309.45 504.575 309.223 505.314 309.45C506.029 309.712 507.185 310.296 508.054 310.905C507.768 309.903 507.542 308.544 507.542 307.733C507.542 306.993 507.959 306.469 508.71 306.469H508.876C509.615 306.469 510.044 306.981 510.044 307.733C510.044 308.544 509.818 309.903 509.532 310.905C510.437 310.284 511.569 309.712 512.272 309.45C512.987 309.223 513.594 309.45 513.821 310.165L513.857 310.261C514.083 311 513.857 311.548 513.046 311.811C512.308 312.037 511.045 312.228 509.973 312.264C510.783 312.884 511.783 313.778 512.272 314.434C512.689 315.018 512.629 315.698 512.081 316.116L511.95 316.211C511.331 316.664 510.723 316.533 510.235 315.889C509.782 315.245 509.234 314.172 508.817 313.075C508.364 314.172 507.816 315.245 507.363 315.889C506.875 316.533 506.267 316.664 505.648 316.211L505.517 316.116C504.933 315.698 504.897 315.018 505.326 314.434C505.814 313.79 506.815 312.884 507.625 312.24C506.589 312.24 505.302 312.049 504.552 311.823V311.811Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.633 311.811C515.822 311.548 515.572 310.94 515.787 310.296L515.846 310.129C516.108 309.45 516.656 309.223 517.395 309.45C518.11 309.712 519.266 310.296 520.135 310.905C519.849 309.903 519.623 308.544 519.623 307.733C519.623 306.993 520.04 306.469 520.791 306.469H520.957C521.696 306.469 522.125 306.981 522.125 307.733C522.125 308.544 521.899 309.903 521.613 310.905C522.518 310.284 523.65 309.712 524.353 309.45C525.068 309.223 525.675 309.45 525.902 310.165L525.938 310.261C526.164 311 525.938 311.548 525.127 311.811C524.389 312.037 523.126 312.228 522.054 312.264C522.864 312.884 523.864 313.778 524.353 314.434C524.77 315.018 524.71 315.698 524.162 316.116L524.031 316.211C523.412 316.664 522.804 316.533 522.316 315.889C521.863 315.245 521.315 314.172 520.898 313.075C520.445 314.172 519.897 315.245 519.444 315.889C518.956 316.533 518.348 316.664 517.729 316.211L517.598 316.116C517.014 315.698 516.978 315.018 517.407 314.434C517.896 313.79 518.896 312.884 519.706 312.24C518.67 312.24 517.383 312.049 516.633 311.823V311.811Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.403 44.0964C193.593 43.834 193.343 43.2259 193.569 42.582L193.629 42.415C193.891 41.7354 194.439 41.5088 195.177 41.7354C195.892 41.9977 197.048 42.582 197.918 43.1901C197.632 42.1885 197.405 40.8291 197.405 40.0182C197.405 39.2789 197.822 38.7543 198.573 38.7543H198.74C199.478 38.7543 199.907 39.267 199.907 40.0182C199.907 40.8291 199.681 42.1885 199.395 43.1901C200.301 42.5701 201.432 41.9977 202.147 41.7354C202.862 41.5088 203.47 41.7354 203.696 42.4508L203.732 42.5462C203.958 43.2855 203.732 43.834 202.922 44.0964C202.183 44.3229 200.92 44.5137 199.848 44.5495C200.658 45.1696 201.659 46.0639 202.147 46.7198C202.564 47.304 202.505 47.9837 201.957 48.4011L201.826 48.4965C201.206 48.9496 200.598 48.8184 200.11 48.1745C199.657 47.5306 199.109 46.4574 198.692 45.3604C198.239 46.4574 197.691 47.5306 197.239 48.1745C196.75 48.8184 196.143 48.9496 195.523 48.4965L195.392 48.4011C194.808 47.9837 194.772 47.304 195.201 46.7198C195.69 46.0758 196.691 45.1696 197.501 44.5257C196.464 44.5257 195.177 44.3349 194.427 44.1083L194.403 44.0964Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.484 44.0964C205.674 43.834 205.424 43.2259 205.65 42.582L205.709 42.415C205.972 41.7354 206.52 41.5088 207.258 41.7354C207.973 41.9977 209.129 42.582 209.999 43.1901C209.713 42.1885 209.486 40.8291 209.486 40.0182C209.486 39.2789 209.903 38.7543 210.654 38.7543H210.821C211.559 38.7543 211.988 39.267 211.988 40.0182C211.988 40.8291 211.762 42.1885 211.476 43.1901C212.381 42.5701 213.513 41.9977 214.228 41.7354C214.943 41.5088 215.551 41.7354 215.777 42.4508L215.813 42.5462C216.039 43.2855 215.813 43.834 215.002 44.0964C214.264 44.3229 213.001 44.5137 211.929 44.5495C212.739 45.1696 213.74 46.0639 214.228 46.7198C214.645 47.304 214.585 47.9837 214.037 48.4011L213.906 48.4965C213.287 48.9496 212.679 48.8184 212.191 48.1745C211.738 47.5306 211.19 46.4574 210.773 45.3604C210.32 46.4574 209.772 47.5306 209.319 48.1745C208.831 48.8184 208.223 48.9496 207.604 48.4965L207.473 48.4011C206.889 47.9837 206.853 47.304 207.282 46.7198C207.771 46.0758 208.771 45.1696 209.582 44.5257C208.545 44.5257 207.258 44.3349 206.508 44.1083L206.484 44.0964Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.565 44.0964C217.755 43.834 217.505 43.2259 217.731 42.582L217.791 42.415C218.053 41.7354 218.601 41.5088 219.339 41.7354C220.054 41.9977 221.21 42.582 222.092 43.1901C221.806 42.1885 221.579 40.8291 221.579 40.0182C221.579 39.2789 221.996 38.7543 222.747 38.7543H222.914C223.652 38.7543 224.081 39.267 224.081 40.0182C224.081 40.8291 223.855 42.1885 223.569 43.1901C224.474 42.5701 225.606 41.9977 226.321 41.7354C227.036 41.5088 227.643 41.7354 227.87 42.4508L227.906 42.5462C228.132 43.2855 227.906 43.834 227.095 44.0964C226.357 44.3229 225.094 44.5137 224.022 44.5495C224.832 45.1696 225.833 46.0639 226.321 46.7198C226.738 47.304 226.678 47.9837 226.13 48.4011L225.999 48.4965C225.38 48.9496 224.772 48.8184 224.284 48.1745C223.831 47.5306 223.283 46.4574 222.866 45.3604C222.413 46.4574 221.865 47.5306 221.412 48.1745C220.924 48.8184 220.316 48.9496 219.697 48.4965L219.566 48.4011C218.982 47.9837 218.946 47.304 219.375 46.7198C219.864 46.0758 220.864 45.1696 221.675 44.5257C220.638 44.5257 219.351 44.3349 218.601 44.1083L218.565 44.0964Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.646 44.0964C229.836 43.834 229.585 43.2259 229.812 42.582L229.871 42.415C230.133 41.7354 230.681 41.5088 231.42 41.7354C232.135 41.9977 233.291 42.582 234.16 43.1901C233.874 42.1885 233.648 40.8291 233.648 40.0182C233.648 39.2789 234.065 38.7543 234.816 38.7543H234.982C235.721 38.7543 236.15 39.267 236.15 40.0182C236.15 40.8291 235.924 42.1885 235.638 43.1901C236.543 42.5701 237.675 41.9977 238.39 41.7354C239.105 41.5088 239.712 41.7354 239.939 42.4508L239.974 42.5462C240.201 43.2855 239.975 43.834 239.164 44.0964C238.426 44.3229 237.163 44.5137 236.09 44.5495C236.901 45.1696 237.901 46.0639 238.39 46.7198C238.807 47.304 238.747 47.9837 238.199 48.4011L238.068 48.4965C237.449 48.9496 236.841 48.8184 236.353 48.1745C235.9 47.5306 235.352 46.4574 234.935 45.3604C234.482 46.4574 233.934 47.5306 233.481 48.1745C232.993 48.8184 232.385 48.9496 231.766 48.4965L231.635 48.4011C231.051 47.9837 231.015 47.304 231.444 46.7198C231.932 46.0758 232.933 45.1696 233.743 44.5257C232.707 44.5257 231.42 44.3349 230.67 44.1083L230.646 44.0964Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.727 44.0964C241.917 43.834 241.666 43.2259 241.893 42.582L241.952 42.415C242.214 41.7354 242.763 41.5088 243.501 41.7354C244.216 41.9977 245.372 42.582 246.241 43.1901C245.956 42.1885 245.729 40.8291 245.729 40.0182C245.729 39.2789 246.146 38.7543 246.897 38.7543H247.064C247.802 38.7543 248.231 39.267 248.231 40.0182C248.231 40.8291 248.005 42.1885 247.719 43.1901C248.624 42.5701 249.756 41.9977 250.459 41.7354C251.174 41.5088 251.782 41.7354 252.008 42.4508L252.044 42.5462C252.27 43.2855 252.044 43.834 251.233 44.0964C250.495 44.3229 249.232 44.5137 248.16 44.5495C248.97 45.1696 249.971 46.0639 250.459 46.7198C250.876 47.304 250.816 47.9837 250.268 48.4011L250.137 48.4965C249.518 48.9496 248.91 48.8184 248.422 48.1745C247.969 47.5306 247.421 46.4574 247.004 45.3604C246.551 46.4574 246.003 47.5306 245.55 48.1745C245.062 48.8184 244.454 48.9496 243.835 48.4965L243.704 48.4011C243.12 47.9837 243.084 47.304 243.513 46.7198C244.002 46.0758 245.002 45.1696 245.813 44.5257C244.776 44.5257 243.489 44.3349 242.739 44.1083L242.727 44.0964Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.808 44.0964C253.998 43.834 253.747 43.2259 253.962 42.582L254.021 42.415C254.283 41.7354 254.831 41.5088 255.57 41.7354C256.285 41.9977 257.441 42.582 258.31 43.1901C258.024 42.1885 257.798 40.8291 257.798 40.0182C257.798 39.2789 258.215 38.7543 258.966 38.7543H259.133C259.871 38.7543 260.3 39.267 260.3 40.0182C260.3 40.8291 260.074 42.1885 259.788 43.1901C260.693 42.5701 261.825 41.9977 262.528 41.7354C263.243 41.5088 263.85 41.7354 264.077 42.4508L264.113 42.5462C264.339 43.2855 264.113 43.834 263.302 44.0964C262.564 44.3229 261.301 44.5137 260.229 44.5495C261.039 45.1696 262.04 46.0639 262.516 46.7198C262.933 47.304 262.874 47.9837 262.325 48.4011L262.194 48.4965C261.575 48.9496 260.967 48.8184 260.479 48.1745C260.026 47.5306 259.478 46.4574 259.061 45.3604C258.608 46.4574 258.06 47.5306 257.607 48.1745C257.119 48.8184 256.511 48.9496 255.892 48.4965L255.761 48.4011C255.177 47.9837 255.141 47.304 255.57 46.7198C256.059 46.0758 257.059 45.1696 257.87 44.5257C256.833 44.5257 255.546 44.3349 254.796 44.1083L254.808 44.0964Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.889 44.0964C266.079 43.834 265.828 43.2259 266.043 42.582L266.102 42.415C266.365 41.7354 266.913 41.5088 267.651 41.7354C268.366 41.9977 269.522 42.582 270.391 43.1901C270.106 42.1885 269.879 40.8291 269.879 40.0182C269.879 39.2789 270.296 38.7543 271.047 38.7543H271.214C271.952 38.7543 272.381 39.267 272.381 40.0182C272.381 40.8291 272.155 42.1885 271.869 43.1901C272.774 42.5701 273.906 41.9977 274.609 41.7354C275.324 41.5088 275.932 41.7354 276.158 42.4508L276.194 42.5462C276.42 43.2855 276.194 43.834 275.384 44.0964C274.645 44.3229 273.382 44.5137 272.31 44.5495C273.12 45.1696 274.121 46.0639 274.609 46.7198C275.026 47.304 274.967 47.9837 274.418 48.4011L274.287 48.4965C273.668 48.9496 273.06 48.8184 272.572 48.1745C272.119 47.5306 271.571 46.4574 271.154 45.3604C270.701 46.4574 270.153 47.5306 269.7 48.1745C269.212 48.8184 268.604 48.9496 267.985 48.4965L267.854 48.4011C267.27 47.9837 267.234 47.304 267.663 46.7198C268.152 46.0758 269.152 45.1696 269.963 44.5257C268.926 44.5257 267.639 44.3349 266.889 44.1083V44.0964Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.97 44.0964C278.159 43.834 277.909 43.2259 278.124 42.582L278.183 42.415C278.445 41.7354 278.993 41.5088 279.732 41.7354C280.447 41.9977 281.603 42.582 282.472 43.1901C282.186 42.1885 281.96 40.8291 281.96 40.0182C281.96 39.2789 282.377 38.7543 283.128 38.7543H283.294C284.033 38.7543 284.462 39.267 284.462 40.0182C284.462 40.8291 284.236 42.1885 283.95 43.1901C284.855 42.5701 285.987 41.9977 286.69 41.7354C287.405 41.5088 288.012 41.7354 288.239 42.4508L288.274 42.5462C288.501 43.2855 288.274 43.834 287.464 44.0964C286.726 44.3229 285.463 44.5137 284.39 44.5495C285.201 45.1696 286.201 46.0639 286.69 46.7198C287.107 47.304 287.047 47.9837 286.499 48.4011L286.368 48.4965C285.749 48.9496 285.141 48.8184 284.653 48.1745C284.2 47.5306 283.652 46.4574 283.235 45.3604C282.782 46.4574 282.234 47.5306 281.781 48.1745C281.293 48.8184 280.685 48.9496 280.066 48.4965L279.935 48.4011C279.351 47.9837 279.315 47.304 279.744 46.7198C280.232 46.0758 281.233 45.1696 282.043 44.5257C281.007 44.5257 279.72 44.3349 278.97 44.1083V44.0964Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.53 421.622C294.72 421.36 294.47 420.752 294.696 420.108L294.756 419.941C295.018 419.262 295.566 419.035 296.305 419.261C297.02 419.524 298.175 420.108 299.045 420.716C298.759 419.715 298.533 418.355 298.533 417.544C298.533 416.805 298.95 416.28 299.7 416.28H299.867C300.606 416.28 301.035 416.793 301.035 417.544C301.035 418.355 300.808 419.715 300.522 420.716C301.428 420.096 302.56 419.524 303.274 419.261C303.989 419.035 304.597 419.261 304.823 419.977L304.859 420.072C305.085 420.812 304.859 421.36 304.049 421.622C303.31 421.849 302.047 422.04 300.975 422.076C301.785 422.696 302.786 423.59 303.274 424.246C303.691 424.83 303.632 425.51 303.084 425.927L302.953 426.023C302.333 426.476 301.726 426.345 301.237 425.701C300.784 425.057 300.236 423.984 299.819 422.887C299.367 423.984 298.819 425.057 298.366 425.701C297.877 426.345 297.27 426.476 296.65 426.023L296.519 425.927C295.935 425.51 295.9 424.83 296.328 424.246C296.817 423.602 297.818 422.696 298.628 422.052C297.591 422.052 296.305 421.861 295.554 421.634L295.53 421.622Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.611 421.622C306.801 421.36 306.551 420.752 306.777 420.108L306.837 419.941C307.099 419.262 307.647 419.035 308.385 419.261C309.1 419.524 310.256 420.108 311.126 420.716C310.84 419.715 310.613 418.355 310.613 417.544C310.613 416.805 311.03 416.28 311.781 416.28H311.948C312.686 416.28 313.115 416.793 313.115 417.544C313.115 418.355 312.889 419.715 312.603 420.716C313.509 420.096 314.64 419.524 315.355 419.261C316.07 419.035 316.678 419.261 316.904 419.977L316.94 420.072C317.166 420.812 316.94 421.36 316.13 421.622C315.391 421.849 314.128 422.04 313.056 422.076C313.866 422.696 314.867 423.59 315.355 424.246C315.772 424.83 315.713 425.51 315.165 425.927L315.034 426.023C314.414 426.476 313.806 426.345 313.318 425.701C312.865 425.057 312.317 423.984 311.9 422.887C311.447 423.984 310.899 425.057 310.447 425.701C309.958 426.345 309.351 426.476 308.731 426.023L308.6 425.927C308.016 425.51 307.98 424.83 308.409 424.246C308.898 423.602 309.899 422.696 310.709 422.052C309.672 422.052 308.385 421.861 307.635 421.634L307.611 421.622Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.692 421.622C318.882 421.36 318.632 420.752 318.858 420.108L318.918 419.941C319.18 419.262 319.728 419.035 320.467 419.261C321.181 419.524 322.337 420.108 323.219 420.716C322.933 419.715 322.706 418.355 322.706 417.544C322.706 416.805 323.123 416.28 323.874 416.28H324.041C324.779 416.28 325.208 416.793 325.208 417.544C325.208 418.355 324.982 419.715 324.696 420.716C325.602 420.096 326.733 419.524 327.448 419.261C328.163 419.035 328.771 419.261 328.997 419.977L329.033 420.072C329.259 420.812 329.033 421.36 328.223 421.622C327.484 421.849 326.221 422.04 325.149 422.076C325.959 422.696 326.96 423.59 327.448 424.246C327.865 424.83 327.806 425.51 327.258 425.927L327.127 426.023C326.507 426.476 325.899 426.345 325.411 425.701C324.958 425.057 324.41 423.984 323.993 422.887C323.54 423.984 322.992 425.057 322.54 425.701C322.051 426.345 321.443 426.476 320.824 426.023L320.693 425.927C320.109 425.51 320.073 424.83 320.502 424.246C320.991 423.602 321.992 422.696 322.802 422.052C321.765 422.052 320.478 421.861 319.728 421.634L319.692 421.622Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.773 421.622C330.963 421.36 330.713 420.752 330.939 420.108L330.999 419.941C331.261 419.262 331.809 419.035 332.547 419.261C333.262 419.524 334.418 420.108 335.288 420.716C335.002 419.715 334.775 418.355 334.775 417.544C334.775 416.805 335.192 416.28 335.943 416.28H336.11C336.848 416.28 337.277 416.793 337.277 417.544C337.277 418.355 337.051 419.715 336.765 420.716C337.67 420.096 338.802 419.524 339.517 419.261C340.232 419.035 340.84 419.261 341.066 419.977L341.102 420.072C341.328 420.812 341.102 421.36 340.292 421.622C339.553 421.849 338.29 422.04 337.218 422.076C338.028 422.696 339.029 423.59 339.517 424.246C339.934 424.83 339.875 425.51 339.326 425.927L339.195 426.023C338.576 426.476 337.968 426.345 337.48 425.701C337.027 425.057 336.479 423.984 336.062 422.887C335.609 423.984 335.061 425.057 334.609 425.701C334.12 426.345 333.512 426.476 332.893 426.023L332.762 425.927C332.178 425.51 332.142 424.83 332.571 424.246C333.06 423.602 334.06 422.696 334.871 422.052C333.834 422.052 332.547 421.861 331.797 421.634L331.773 421.622Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.854 421.622C343.044 421.36 342.794 420.752 343.02 420.108L343.08 419.941C343.342 419.262 343.89 419.035 344.628 419.261C345.343 419.524 346.499 420.108 347.369 420.716C347.083 419.715 346.856 418.355 346.856 417.544C346.856 416.805 347.273 416.28 348.024 416.28H348.191C348.929 416.28 349.358 416.793 349.358 417.544C349.358 418.355 349.132 419.715 348.846 420.716C349.751 420.096 350.883 419.524 351.586 419.261C352.301 419.035 352.909 419.261 353.135 419.977L353.171 420.072C353.397 420.812 353.171 421.36 352.361 421.622C351.622 421.849 350.359 422.04 349.287 422.076C350.097 422.696 351.098 423.59 351.586 424.246C352.003 424.83 351.944 425.51 351.396 425.927L351.265 426.023C350.645 426.476 350.037 426.345 349.549 425.701C349.096 425.057 348.548 423.984 348.131 422.887C347.678 423.984 347.13 425.057 346.678 425.701C346.189 426.345 345.582 426.476 344.962 426.023L344.831 425.927C344.247 425.51 344.211 424.83 344.64 424.246C345.129 423.602 346.13 422.696 346.94 422.052C345.903 422.052 344.616 421.861 343.866 421.634L343.854 421.622Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.935 421.622C355.125 421.36 354.875 420.752 355.089 420.108L355.149 419.941C355.411 419.262 355.959 419.035 356.697 419.261C357.412 419.524 358.568 420.108 359.438 420.716C359.152 419.715 358.925 418.355 358.925 417.544C358.925 416.805 359.342 416.28 360.093 416.28H360.26C360.998 416.28 361.427 416.793 361.427 417.544C361.427 418.355 361.201 419.715 360.915 420.716C361.82 420.096 362.952 419.524 363.655 419.261C364.37 419.035 364.978 419.261 365.204 419.977L365.24 420.072C365.466 420.812 365.24 421.36 364.43 421.622C363.691 421.849 362.428 422.04 361.356 422.076C362.166 422.696 363.167 423.59 363.643 424.246C364.06 424.83 364.001 425.51 363.453 425.927L363.322 426.023C362.702 426.476 362.094 426.345 361.606 425.701C361.153 425.057 360.605 423.984 360.188 422.887C359.735 423.984 359.187 425.057 358.735 425.701C358.246 426.345 357.639 426.476 357.019 426.023L356.888 425.927C356.304 425.51 356.268 424.83 356.697 424.246C357.186 423.602 358.187 422.696 358.997 422.052C357.96 422.052 356.674 421.861 355.923 421.634L355.935 421.622Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.016 421.622C367.206 421.36 366.956 420.752 367.17 420.108L367.23 419.941C367.492 419.262 368.04 419.035 368.778 419.261C369.493 419.524 370.649 420.108 371.519 420.716C371.233 419.715 371.006 418.355 371.006 417.544C371.006 416.805 371.423 416.28 372.174 416.28H372.341C373.079 416.28 373.508 416.793 373.508 417.544C373.508 418.355 373.282 419.715 372.996 420.716C373.902 420.096 375.033 419.524 375.736 419.261C376.451 419.035 377.059 419.261 377.285 419.977L377.321 420.072C377.547 420.812 377.321 421.36 376.511 421.622C375.772 421.849 374.509 422.04 373.437 422.076C374.247 422.696 375.248 423.59 375.736 424.246C376.153 424.83 376.094 425.51 375.546 425.927L375.415 426.023C374.795 426.476 374.187 426.345 373.699 425.701C373.246 425.057 372.698 423.984 372.281 422.887C371.828 423.984 371.28 425.057 370.828 425.701C370.339 426.345 369.732 426.476 369.112 426.023L368.981 425.927C368.397 425.51 368.361 424.83 368.79 424.246C369.279 423.602 370.28 422.696 371.09 422.052C370.053 422.052 368.767 421.861 368.016 421.634V421.622Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.097 421.622C379.287 421.36 379.036 420.752 379.251 420.108L379.31 419.941C379.573 419.262 380.121 419.035 380.859 419.261C381.574 419.524 382.73 420.108 383.599 420.716C383.314 419.715 383.087 418.355 383.087 417.544C383.087 416.805 383.504 416.28 384.255 416.28H384.422C385.16 416.28 385.589 416.793 385.589 417.544C385.589 418.355 385.363 419.715 385.077 420.716C385.982 420.096 387.114 419.524 387.817 419.261C388.532 419.035 389.14 419.261 389.366 419.977L389.402 420.072C389.628 420.812 389.402 421.36 388.592 421.622C387.853 421.849 386.59 422.04 385.518 422.076C386.328 422.696 387.329 423.59 387.817 424.246C388.234 424.83 388.175 425.51 387.626 425.927L387.495 426.023C386.876 426.476 386.268 426.345 385.78 425.701C385.327 425.057 384.779 423.984 384.362 422.887C383.909 423.984 383.361 425.057 382.908 425.701C382.42 426.345 381.812 426.476 381.193 426.023L381.062 425.927C380.478 425.51 380.442 424.83 380.871 424.246C381.36 423.602 382.36 422.696 383.171 422.052C382.134 422.052 380.847 421.861 380.097 421.634V421.622Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M488.229 362.955V354.464C488.229 349.23 492.578 344.973 497.916 344.973C503.253 344.973 507.602 349.23 507.602 354.464V362.895H511.462V354.464C511.462 347.143 505.386 341.193 497.916 341.193C490.445 341.193 484.369 347.143 484.369 354.464V362.955H488.229Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.51 362.978H482.927V387.471H512.51V362.978Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.799 373.15C500.799 371.409 499.357 369.99 497.582 369.99C495.807 369.99 494.365 371.397 494.365 373.15C494.365 374.354 495.044 375.392 496.057 375.928L495.521 381.497H499.667L499.131 375.928C500.143 375.392 500.822 374.354 500.822 373.15H500.799Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.1021 96.5637V88.0735C69.1021 82.8387 73.4508 78.5817 78.7883 78.5817C84.1258 78.5817 88.4745 82.8387 88.4745 88.0735V96.5041H92.3347V88.0735C92.3347 80.752 86.2585 74.8017 78.7883 74.8017C71.3181 74.8017 65.2419 80.752 65.2419 88.0735V96.5637H69.1021Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3831 96.5875H63.8003V121.08H93.3831V96.5875Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6714 106.759C81.6714 105.018 80.2298 103.599 78.4546 103.599C76.6794 103.599 75.2378 105.006 75.2378 106.759C75.2378 107.963 75.9169 109.001 76.9296 109.537L76.3935 115.106H80.5396L80.0034 109.537C81.0161 109.001 81.6953 107.963 81.6953 106.759H81.6714Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M438.452 32.3986V26.8299C438.452 23.3956 441.3 20.6053 444.814 20.6053C448.329 20.6053 451.176 23.3956 451.176 26.8299V32.3628H453.714V26.8299C453.714 22.0243 449.723 18.1131 444.826 18.1131C439.929 18.1131 435.938 22.0243 435.938 26.8299V32.3986H438.476H438.452Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.381 32.4105H434.973V48.4846H454.381V32.4105Z",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.697 39.0881C446.697 37.9434 445.755 37.0133 444.588 37.0133C443.42 37.0133 442.479 37.9434 442.479 39.0881C442.479 39.8751 442.932 40.5668 443.587 40.9126L443.23 44.5614H445.946L445.589 40.9126C446.244 40.5668 446.697 39.8751 446.697 39.0881Z",
    stroke: "black",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M495.425 81.8252H116.222V283.395H495.425V81.8252Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.425 81.8252H182.31V100.725H495.425V81.8252Z",
    fill: "#D9D9D9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.413 81.8252H248.708V100.725H495.413V81.8252Z",
    fill: "#A8A8A8",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.425 63.3543H115.913V82.2544H495.425V63.3543Z",
    fill: "#62B6FF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.394 76.5427H132.628C130.376 76.5427 128.542 74.7182 128.542 72.4526C128.542 70.1989 130.364 68.3625 132.628 68.3625H379.382C381.633 68.3625 383.468 70.187 383.468 72.4526C383.468 74.7063 381.645 76.5427 379.382 76.5427H379.394Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.869 76.4353C455.764 76.4353 457.3 74.8978 457.3 73.0011C457.3 71.1044 455.764 69.5669 453.869 69.5669C451.974 69.5669 450.438 71.1044 450.438 73.0011C450.438 74.8978 451.974 76.4353 453.869 76.4353Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.609 73.0011C471.609 71.1051 470.072 69.5669 468.178 69.5669C466.284 69.5669 464.747 71.1051 464.747 73.0011C464.747 74.8971 466.284 76.4353 468.178 76.4353C470.072 76.4353 471.609 74.8971 471.609 73.0011Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.487 76.4353C484.382 76.4353 485.918 74.8978 485.918 73.0011C485.918 71.1044 484.382 69.5669 482.487 69.5669C480.592 69.5669 479.055 71.1044 479.055 73.0011C479.055 74.8978 480.592 76.4353 482.487 76.4353Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.718 162.529H182.882V133.887H158.41L155.92 126.899H140.718V162.529Z",
    fill: "#D9D9D9",
    stroke: "#B5B5B5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.718 217.847H182.882V189.204H158.41L155.92 182.217H140.718V217.847Z",
    fill: "#D9D9D9",
    stroke: "#B5B5B5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.718 273.164H182.882V244.522H158.41L155.92 237.534H140.718V273.164Z",
    fill: "#D9D9D9",
    stroke: "#B5B5B5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.3 162.529H241.452V133.887H216.98L214.502 126.899H199.3V162.529Z",
    fill: "#D9D9D9",
    stroke: "#B5B5B5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.3 217.847H241.452V189.204H216.98L214.502 182.217H199.3V217.847Z",
    fill: "#D9D9D9",
    stroke: "#B5B5B5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.3 273.164H241.452V244.522H216.98L214.502 237.534H199.3V273.164Z",
    fill: "#D9D9D9",
    stroke: "#B5B5B5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.869 162.529H300.034V133.887H275.562L273.072 126.899H257.869V162.529Z",
    fill: "#D9D9D9",
    stroke: "#B5B5B5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.869 217.847H300.034V189.204H275.562L273.072 182.217H257.869V217.847Z",
    fill: "#D9D9D9",
    stroke: "#B5B5B5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.869 273.164H300.034V244.522H275.562L273.072 237.534H257.869V273.164Z",
    fill: "#D9D9D9",
    stroke: "#B5B5B5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.451 162.529H358.603V133.887H334.132L331.654 126.899H316.451V162.529Z",
    fill: "#D9D9D9",
    stroke: "#B5B5B5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.451 217.847H358.603V189.204H334.132L331.654 182.217H316.451V217.847Z",
    fill: "#D9D9D9",
    stroke: "#B5B5B5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.451 273.164H358.603V244.522H334.132L331.654 237.534H316.451V273.164Z",
    fill: "#D9D9D9",
    stroke: "#B5B5B5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.021 162.529H417.185V133.887H392.714L390.224 126.899H375.021V162.529Z",
    fill: "#D9D9D9",
    stroke: "#B5B5B5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.021 217.847H417.185V189.204H392.714L390.224 182.217H375.021V217.847Z",
    fill: "#D9D9D9",
    stroke: "#B5B5B5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.021 273.164H417.185V244.522H392.714L390.224 237.534H375.021V273.164Z",
    fill: "#D9D9D9",
    stroke: "#B5B5B5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.603 162.529H475.755V133.887H451.284L448.805 126.899H433.603V162.529Z",
    fill: "#D9D9D9",
    stroke: "#B5B5B5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.603 217.847H475.755V189.204H451.284L448.805 182.217H433.603V217.847Z",
    fill: "#D9D9D9",
    stroke: "#B5B5B5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.603 273.164H475.755V244.522H451.284L448.805 237.534H433.603V273.164Z",
    fill: "#D9D9D9",
    stroke: "#B5B5B5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M376.784 121.641H224.879V255.79H376.784V121.641Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.585 114.784H228.68V248.934H380.585V114.784Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.585 114.784H228.68V124.371H380.585V114.784Z",
    fill: "#62B6FF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.137 172.236V158.094C295.137 152.859 299.485 148.602 304.823 148.602C310.161 148.602 314.509 152.859 314.509 158.094V166.357H318.369V158.094C318.369 150.772 312.293 144.822 304.823 144.822C297.353 144.822 291.277 150.772 291.277 158.094V172.236H295.137Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.43 170.853H289.847V195.345H319.43V170.853Z",
    fill: "#0088FF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.647 161.874L325.565 157.485",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.921 167.073H331.046",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.099 172.009L326.936 176.123",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.706 181.024C307.706 179.283 306.264 177.864 304.489 177.864C302.714 177.864 301.272 179.271 301.272 181.024C301.272 182.229 301.952 183.266 302.964 183.803L302.428 189.371H306.574L306.038 183.803C307.051 183.266 307.73 182.229 307.73 181.024H307.706Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.603 205.326H251.674C249.042 205.326 246.908 207.462 246.908 210.096V221.412C246.908 224.046 249.042 226.182 251.674 226.182H357.603C360.235 226.182 362.368 224.046 362.368 221.412V210.096C362.368 207.462 360.235 205.326 357.603 205.326Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.12 216.416C257.309 216.153 257.059 215.545 257.286 214.901L257.345 214.734C257.607 214.055 258.155 213.828 258.894 214.055C259.609 214.317 260.765 214.901 261.634 215.509C261.348 214.508 261.122 213.148 261.122 212.338C261.122 211.598 261.539 211.074 262.29 211.074H262.456C263.195 211.074 263.624 211.586 263.624 212.338C263.624 213.148 263.398 214.508 263.112 215.509C264.017 214.889 265.149 214.317 265.864 214.055C266.579 213.828 267.186 214.055 267.413 214.77L267.448 214.866C267.675 215.605 267.448 216.153 266.638 216.416C265.9 216.642 264.637 216.833 263.564 216.869C264.375 217.489 265.375 218.383 265.864 219.039C266.281 219.623 266.221 220.303 265.673 220.72L265.542 220.816C264.923 221.269 264.315 221.138 263.826 220.494C263.374 219.85 262.826 218.777 262.409 217.68C261.956 218.777 261.408 219.85 260.955 220.494C260.467 221.138 259.859 221.269 259.24 220.816L259.108 220.72C258.525 220.303 258.489 219.623 258.918 219.039C259.406 218.395 260.407 217.489 261.217 216.845C260.181 216.845 258.894 216.654 258.143 216.428L258.12 216.416Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.2 216.416C269.39 216.153 269.14 215.545 269.366 214.901L269.426 214.734C269.688 214.055 270.236 213.828 270.975 214.055C271.69 214.317 272.845 214.901 273.715 215.509C273.429 214.508 273.203 213.148 273.203 212.338C273.203 211.598 273.62 211.074 274.37 211.074H274.537C275.276 211.074 275.705 211.586 275.705 212.338C275.705 213.148 275.478 214.508 275.192 215.509C276.098 214.889 277.23 214.317 277.945 214.055C278.659 213.828 279.267 214.055 279.493 214.77L279.529 214.866C279.756 215.605 279.529 216.153 278.719 216.416C277.98 216.642 276.717 216.833 275.645 216.869C276.455 217.489 277.456 218.383 277.945 219.039C278.362 219.623 278.302 220.303 277.754 220.72L277.623 220.816C277.003 221.269 276.396 221.138 275.907 220.494C275.455 219.85 274.907 218.777 274.49 217.68C274.037 218.777 273.489 219.85 273.036 220.494C272.548 221.138 271.94 221.269 271.32 220.816L271.189 220.72C270.605 220.303 270.57 219.623 270.999 219.039C271.487 218.395 272.488 217.489 273.298 216.845C272.262 216.845 270.975 216.654 270.224 216.428L270.2 216.416Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.281 216.416C281.471 216.153 281.221 215.545 281.447 214.901L281.507 214.734C281.769 214.055 282.317 213.828 283.056 214.055C283.771 214.317 284.926 214.901 285.808 215.509C285.522 214.508 285.296 213.148 285.296 212.338C285.296 211.598 285.713 211.074 286.463 211.074H286.63C287.369 211.074 287.798 211.586 287.798 212.338C287.798 213.148 287.571 214.508 287.285 215.509C288.191 214.889 289.323 214.317 290.038 214.055C290.752 213.828 291.36 214.055 291.586 214.77L291.622 214.866C291.849 215.605 291.622 216.153 290.812 216.416C290.073 216.642 288.81 216.833 287.738 216.869C288.548 217.489 289.549 218.383 290.038 219.039C290.455 219.623 290.395 220.303 289.847 220.72L289.716 220.816C289.096 221.269 288.489 221.138 288 220.494C287.548 219.85 286.999 218.777 286.582 217.68C286.13 218.777 285.582 219.85 285.129 220.494C284.64 221.138 284.033 221.269 283.413 220.816L283.282 220.72C282.698 220.303 282.663 219.623 283.092 219.039C283.58 218.395 284.581 217.489 285.391 216.845C284.355 216.845 283.068 216.654 282.317 216.428L282.281 216.416Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.362 216.416C293.552 216.153 293.302 215.545 293.528 214.901L293.588 214.734C293.85 214.055 294.398 213.828 295.137 214.055C295.852 214.317 297.007 214.901 297.877 215.509C297.591 214.508 297.365 213.148 297.365 212.338C297.365 211.598 297.782 211.074 298.532 211.074H298.699C299.438 211.074 299.867 211.586 299.867 212.338C299.867 213.148 299.64 214.508 299.354 215.509C300.26 214.889 301.392 214.317 302.106 214.055C302.821 213.828 303.429 214.055 303.655 214.77L303.691 214.866C303.917 215.605 303.691 216.153 302.881 216.416C302.142 216.642 300.879 216.833 299.807 216.869C300.617 217.489 301.618 218.383 302.106 219.039C302.523 219.623 302.464 220.303 301.916 220.72L301.785 220.816C301.165 221.269 300.558 221.138 300.069 220.494C299.616 219.85 299.068 218.777 298.651 217.68C298.199 218.777 297.651 219.85 297.198 220.494C296.709 221.138 296.102 221.269 295.482 220.816L295.351 220.72C294.767 220.303 294.732 219.623 295.161 219.039C295.649 218.395 296.65 217.489 297.46 216.845C296.423 216.845 295.137 216.654 294.386 216.428L294.362 216.416Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.443 216.416C305.633 216.153 305.383 215.545 305.609 214.901L305.669 214.734C305.931 214.055 306.479 213.828 307.218 214.055C307.933 214.317 309.088 214.901 309.958 215.509C309.672 214.508 309.446 213.148 309.446 212.338C309.446 211.598 309.863 211.074 310.613 211.074H310.78C311.519 211.074 311.948 211.586 311.948 212.338C311.948 213.148 311.721 214.508 311.435 215.509C312.341 214.889 313.473 214.317 314.176 214.055C314.89 213.828 315.498 214.055 315.724 214.77L315.76 214.866C315.987 215.605 315.76 216.153 314.95 216.416C314.211 216.642 312.948 216.833 311.876 216.869C312.686 217.489 313.687 218.383 314.176 219.039C314.593 219.623 314.533 220.303 313.985 220.72L313.854 220.816C313.234 221.269 312.627 221.138 312.138 220.494C311.686 219.85 311.137 218.777 310.72 217.68C310.268 218.777 309.72 219.85 309.267 220.494C308.778 221.138 308.171 221.269 307.551 220.816L307.42 220.72C306.836 220.303 306.801 219.623 307.23 219.039C307.718 218.395 308.719 217.489 309.529 216.845C308.493 216.845 307.206 216.654 306.455 216.428L306.443 216.416Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.524 216.416C317.714 216.153 317.464 215.545 317.678 214.901L317.738 214.734C318 214.055 318.548 213.828 319.287 214.055C320.002 214.317 321.157 214.901 322.027 215.509C321.741 214.508 321.515 213.148 321.515 212.338C321.515 211.598 321.932 211.074 322.682 211.074H322.849C323.588 211.074 324.017 211.586 324.017 212.338C324.017 213.148 323.79 214.508 323.504 215.509C324.41 214.889 325.542 214.317 326.245 214.055C326.959 213.828 327.567 214.055 327.793 214.77L327.829 214.866C328.056 215.605 327.829 216.153 327.019 216.416C326.28 216.642 325.017 216.833 323.945 216.869C324.755 217.489 325.756 218.383 326.233 219.039C326.65 219.623 326.59 220.303 326.042 220.72L325.911 220.816C325.291 221.269 324.684 221.138 324.195 220.494C323.743 219.85 323.195 218.777 322.778 217.68C322.325 218.777 321.777 219.85 321.324 220.494C320.836 221.138 320.228 221.269 319.608 220.816L319.477 220.72C318.894 220.303 318.858 219.623 319.287 219.039C319.775 218.395 320.776 217.489 321.586 216.845C320.55 216.845 319.263 216.654 318.512 216.428L318.524 216.416Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.605 216.416C329.795 216.153 329.545 215.545 329.759 214.901L329.819 214.734C330.081 214.055 330.629 213.828 331.368 214.055C332.082 214.317 333.238 214.901 334.108 215.509C333.822 214.508 333.595 213.148 333.595 212.338C333.595 211.598 334.012 211.074 334.763 211.074H334.93C335.669 211.074 336.097 211.586 336.097 212.338C336.097 213.148 335.871 214.508 335.585 215.509C336.491 214.889 337.622 214.317 338.325 214.055C339.04 213.828 339.648 214.055 339.874 214.77L339.91 214.866C340.136 215.605 339.91 216.153 339.1 216.416C338.361 216.642 337.098 216.833 336.026 216.869C336.836 217.489 337.837 218.383 338.325 219.039C338.742 219.623 338.683 220.303 338.135 220.72L338.004 220.816C337.384 221.269 336.777 221.138 336.288 220.494C335.835 219.85 335.287 218.777 334.87 217.68C334.418 218.777 333.87 219.85 333.417 220.494C332.928 221.138 332.321 221.269 331.701 220.816L331.57 220.72C330.986 220.303 330.951 219.623 331.379 219.039C331.868 218.395 332.869 217.489 333.679 216.845C332.642 216.845 331.356 216.654 330.605 216.428V216.416Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.686 216.416C341.876 216.153 341.626 215.545 341.84 214.901L341.9 214.734C342.162 214.055 342.71 213.828 343.449 214.055C344.163 214.317 345.319 214.901 346.189 215.509C345.903 214.508 345.677 213.148 345.677 212.338C345.677 211.598 346.094 211.074 346.844 211.074H347.011C347.75 211.074 348.178 211.586 348.178 212.338C348.178 213.148 347.952 214.508 347.666 215.509C348.572 214.889 349.703 214.317 350.406 214.055C351.121 213.828 351.729 214.055 351.955 214.77L351.991 214.866C352.217 215.605 351.991 216.153 351.181 216.416C350.442 216.642 349.179 216.833 348.107 216.869C348.917 217.489 349.918 218.383 350.406 219.039C350.823 219.623 350.764 220.303 350.216 220.72L350.085 220.816C349.465 221.269 348.858 221.138 348.369 220.494C347.916 219.85 347.368 218.777 346.951 217.68C346.499 218.777 345.951 219.85 345.498 220.494C345.009 221.138 344.402 221.269 343.782 220.816L343.651 220.72C343.067 220.303 343.032 219.623 343.46 219.039C343.949 218.395 344.95 217.489 345.76 216.845C344.723 216.845 343.437 216.654 342.686 216.428V216.416Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.371 520.5H157.481C158.041 520.5 158.506 520.058 158.541 519.498L161.806 485.466H149.058L152.322 519.498C152.346 520.058 152.811 520.5 153.382 520.5H153.371Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.661 520.5H117.771C118.331 520.5 118.796 520.058 118.832 519.498L122.096 485.466H109.348L112.612 519.498C112.636 520.058 113.101 520.5 113.673 520.5H113.661Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.39 520.5H182.501C183.061 520.5 183.525 520.058 183.561 519.498L186.826 485.466H174.077L177.342 519.498C177.366 520.058 177.83 520.5 178.402 520.5H178.39Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.696 520.5H223.807C224.367 520.5 224.831 520.058 224.867 519.498L228.132 485.466H215.384L218.648 519.498C218.672 520.058 219.137 520.5 219.708 520.5H219.696Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.578 486.861H241.213C241.213 486.861 249.565 458.958 256.058 432.033C262.552 405.107 269.974 371.218 262.087 364.254C254.2 357.29 233.326 369.358 217.552 372.613C201.778 375.869 198.537 372.148 187.862 361.011C177.199 349.873 167.918 331.76 149.82 320.158C131.734 308.555 118.283 306.695 105.75 314.589C105.75 314.589 93.2279 325.262 92.2986 343.375C91.3693 361.476 96.4686 384.228 102.962 396.76C109.455 409.293 159.554 486.873 159.554 486.873L159.578 486.861Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.104 435.777H236.269C236.269 435.777 252.151 419.882 254.533 381.724",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.748 281.475L199.764 287.58C199.764 287.58 206.698 325.607 205.03 345.593C203.362 365.578 195.046 384.728 195.046 384.728H221.948C221.948 384.728 231.932 360.856 236.364 344.197C240.796 327.539 233.04 288.403 233.04 288.403L209.748 281.463V281.475Z",
    fill: "#757575",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.419 382.832C320.419 382.832 326.161 381.02 327.686 381.02C329.223 381.02 334.215 384.943 334.215 384.943C334.215 384.943 334.418 386.374 333.286 386.684C332.154 386.982 328.282 384.299 328.282 384.299L321.825 386.207L320.407 382.821L320.419 382.832Z",
    fill: "#D9D9D9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.05 379.172C321.05 379.172 326.995 380.09 328.365 380.77C329.735 381.461 332.488 387.185 332.488 387.185C332.488 387.185 332.035 388.556 330.891 388.33C329.747 388.103 327.46 383.977 327.46 383.977L320.824 382.832L321.05 379.172Z",
    fill: "#D9D9D9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.783 377.347L322.325 379.184L327.126 382.391L329.867 389.033C329.867 389.033 328.949 389.951 327.805 389.725C326.662 389.498 321.86 384.228 321.86 384.228L314.998 379.875L312.71 377.359H314.771L314.783 377.347Z",
    fill: "#D9D9D9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.318 375.296C298.318 375.296 309.982 375.749 312.496 375.749C315.01 375.749 321.646 381.02 322.79 381.473C323.933 381.926 328.735 388.795 328.735 388.795C328.735 388.795 328.961 388.795 327.365 389.248C325.768 389.701 323.242 388.103 323.242 388.103L320.037 384.216L312.257 382.844C312.257 382.844 317.976 385.825 319.346 386.279C320.717 386.732 321.634 388.342 321.181 389.26C320.728 390.178 313.83 387.221 313.83 387.221C313.83 387.221 311.245 388.592 308.505 387.221C305.764 385.849 305.407 385.814 302.488 384.466C299.569 383.119 293.743 379.649 293.743 379.649L298.318 375.296Z",
    fill: "#D9D9D9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.866 293.686C238.866 293.686 243.298 294.52 244.418 297.013C245.526 299.505 252.734 356.134 252.734 356.134L300.379 373.567L299.474 390.273C299.474 390.273 243.024 383.333 239.14 384.168C235.256 385.003 225.832 386.112 221.948 383.059C218.064 380.006 232.802 367.235 235.483 355.49C241.833 327.67 241.047 308.591 241.047 308.591C241.047 308.591 233.326 290.359 238.866 293.686Z",
    fill: "#62B6FF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.966 326.156C244.966 326.156 238.032 353.916 234.982 361.404C231.932 368.893 225.832 381.39 225.832 381.39L219.172 382.499C219.172 382.499 233.04 352.521 235.53 340.584C238.021 328.648 232.48 298.396 232.206 297.287C231.932 296.178 234.148 289.238 238.306 290.621",
    fill: "#62B6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.966 326.156C244.966 326.156 238.032 353.916 234.982 361.404C231.932 368.893 225.832 381.39 225.832 381.39L219.172 382.499C219.172 382.499 233.04 352.521 235.53 340.584C238.021 328.648 232.48 298.396 232.206 297.287C231.932 296.178 234.148 289.238 238.306 290.621",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.481 318.393L224.438 338.653L215.848 316.998L226.106 308.949L232.481 318.393Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.423 302.009L237.473 325.607L224.438 315.615L234.423 302.009Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.761 260.035C270.761 260.035 270.475 275.704 269.212 277.874C267.949 280.044 265.244 283.395 265.125 286.388C265.018 289.381 268.568 295.844 266.436 297.931C264.291 300.018 261.348 298.992 261.348 298.992C261.348 298.992 254.367 307.363 250.483 309.271C246.599 311.191 236.198 305.717 236.198 305.717L225.832 316.449L206.698 281.749L217.647 274.368C217.647 274.368 221.877 252.559 235.447 247.968C249.017 243.377 268.64 254.538 270.761 260.035Z",
    fill: "#D9D9D9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.54 279.782C232.54 279.782 228.346 288.546 231.944 294.103",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.299 282.429C258.775 283.622 258.799 284.79 259.359 285.041C259.919 285.291 260.8 284.528 261.325 283.335C261.849 282.143 261.825 280.974 261.265 280.724C260.705 280.474 259.823 281.237 259.299 282.429Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.738 299.696C256.738 299.696 252.544 298.861 252.544 295.498",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.464 283.478L259.537 286.281",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.982 277.814C264.982 277.814 264.839 273.7 258.167 275.394",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.899 248.302C276.968 248.624 274.049 250.901 273.072 248.957C272.095 247.014 272.75 239.847 267.877 239.203C263.005 238.547 263.326 240.825 261.706 241.159C260.086 241.481 258.132 234.004 251.96 234.982C245.812 235.96 241.917 238.535 241.571 239.847C230.92 239.764 224.367 244.092 219.673 252.797C214.514 262.348 217.671 274.38 217.671 274.38C217.671 274.38 212.822 278.148 216.706 279.257C220.59 280.366 232.576 279.794 232.576 279.794L231.313 279.233C230.05 278.673 227.989 274.416 232.183 268.382C236.376 262.348 239.224 267.571 239.593 270.159C239.963 272.747 240.189 274.976 241.702 275.656C243.227 276.336 244.264 274.666 244.657 272.413C245.05 270.159 249.637 270.075 253.044 268.549C256.452 267.023 253.211 264.066 250.399 259.475C247.588 254.884 254.736 253.811 261.384 257.984C265.221 260.393 267.222 261.681 269.116 261.919L269.2 261.979C269.2 261.979 272.452 264.578 275.05 262.301C277.647 260.023 279.279 259.701 281.555 257.102C283.83 254.502 282.853 247.992 279.935 248.313L279.899 248.302Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.806 279.806L226.106 315.34L214.454 327.551C214.454 327.551 204.47 300.626 203.362 293.96C202.254 287.294 201.42 282.584 201.42 282.584L207.794 279.806H207.806Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.398 380.138C218.398 380.138 272.011 377.359 278.767 380.138C285.522 382.916 287.107 390.071 286.308 397.225C285.51 404.38 281.543 446.509 279.958 458.433C278.374 470.358 277.575 485.06 278.767 487.851C279.958 490.641 283.532 495.399 282.341 498.189C281.15 500.967 279.16 502.16 279.16 503.352C279.16 504.545 280.745 506.536 280.745 506.536C280.745 506.536 295.435 512.892 300.605 514.883C305.764 516.875 306.169 518.46 304.978 519.259C303.786 520.058 279.16 519.259 274.799 519.259C270.439 519.259 262.087 516.481 262.087 516.481V518.472H251.364V510.924C251.364 506.953 251.757 503.77 251.757 503.77C251.757 503.77 249.768 498.606 250.173 496.615C250.566 494.624 252.949 490.259 253.747 486.277C254.545 482.306 253.747 476.737 253.354 472.361C252.961 467.985 253.354 465.206 253.747 462.821C254.14 460.436 251.364 417.115 251.364 417.115C251.364 417.115 219.994 426.655 216.813 427.048C213.632 427.442 187.826 436.981 177.104 434.203C166.381 431.424 181.476 397.631 193.39 386.112C205.304 374.581 218.41 380.149 218.41 380.149L218.398 380.138Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.559 376.155C196.559 376.155 231.908 378.933 235.876 382.916C239.843 386.887 238.652 394.84 238.652 400.004C238.652 405.167 233.886 473.935 233.493 477.906C233.1 481.876 237.46 485.859 235.876 488.638C234.291 491.416 233.493 494.6 233.493 495.792C233.493 496.985 244.216 505.725 248.588 508.11C252.961 510.495 265.268 513.273 267.258 515.265C269.247 517.256 268.842 518.842 265.268 520.034C261.694 521.227 231.908 520.034 231.908 520.034C231.908 520.034 227.536 520.034 225.951 518.842C224.367 517.65 223.175 517.256 223.175 517.256L222.782 519.915H207.294C207.294 519.915 205.709 510.9 205.709 506.918C205.709 502.935 206.901 496.985 206.901 496.985C206.901 496.985 204.518 493.407 204.911 489.83C205.304 486.253 208.092 484.667 208.092 482.282C208.092 479.897 205.709 472.742 206.102 468.366C206.496 463.99 206.901 458.827 206.901 458.827L203.326 423.852C203.326 423.852 179.498 436.969 167.977 435.777C156.456 434.584 153.287 432.998 150.106 427.43C146.925 421.861 146.925 398.418 152.096 389.272C157.255 380.126 185.848 371.779 196.571 376.155H196.559Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.42 282.584C201.42 282.584 209.736 303.404 210.57 315.889C211.404 328.386 210.296 357.529 207.246 365.852C204.196 374.175 202.814 379.458 202.814 379.458C202.814 379.458 175.078 383.62 171.48 385.015C167.87 386.398 160.388 397.225 158.994 406.383C158.589 409.018 158.315 411.868 158.113 414.587C157.648 420.812 158.267 427.036 159.506 433.153C159.733 434.298 159.78 435.24 159.435 435.586C158.327 436.695 143.47 429.982 138.478 412.775C133.486 395.568 135.988 375.296 140.42 365.864C144.852 356.432 162.056 300.077 169.538 292.589C177.032 285.088 201.432 282.596 201.432 282.596L201.42 282.584Z",
    fill: "#62B6FF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.256 382.582C295.256 382.582 305.729 383.93 308.433 384.609C311.138 385.289 312.972 387.745 312.972 387.745L311.948 388.687L304.37 385.814L295.244 382.582H295.256Z",
    fill: "#D9D9D9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.545 384.251C299.545 384.251 305.943 384.645 306.729 385.432C307.516 386.219 310.911 391.967 310.911 391.967L309.339 393.016L305.026 388.962L299.533 385.957V384.251H299.545Z",
    fill: "#D9D9D9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.774 381.89C287.774 381.89 299.652 382.904 302.023 384.251C304.394 385.599 307.385 391.692 307.385 391.692L305.693 392.372L299.95 386.624L285.749 384.251L287.774 381.879V381.89Z",
    fill: "#D9D9D9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.262 387.912C287.262 387.912 290.526 389.617 292.23 389.617C293.934 389.617 299.283 387.781 299.283 387.781C299.283 387.781 293.922 385.563 292.885 385.432C291.837 385.301 287.274 387.912 287.274 387.912H287.262Z",
    fill: "#D9D9D9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.239 376.477C273.239 376.477 287.44 379.863 289.12 380.877C290.8 381.89 298.926 385.957 299.938 386.624C300.951 387.304 303.989 392.718 303.989 392.718C303.989 392.718 301.964 395.091 301.285 393.398C300.606 391.704 297.567 388.664 297.567 388.664L291.479 386.636C291.479 386.636 288.096 388.33 284.379 388.33C280.661 388.33 276.658 384.657 276.658 384.657L269.843 386.291L273.227 376.477H273.239Z",
    fill: "#D9D9D9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.244 297.203C189.244 297.203 197.667 304.561 198.37 312.86C199.073 321.16 198.954 324.498 199.026 325.894C199.097 327.277 204.029 363.753 204.029 363.753L274.835 375.237L273.477 390.977L192.794 389.427C192.794 389.427 187.302 390.536 184.312 386.517C181.333 382.499 164.105 321.553 164.105 321.553",
    fill: "#62B6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.244 297.203C189.244 297.203 197.667 304.561 198.37 312.86C199.073 321.16 198.954 324.498 199.026 325.894C199.097 327.277 204.029 363.753 204.029 363.753L274.835 375.237L273.477 390.977L192.794 389.427C192.794 389.427 187.302 390.536 184.312 386.517C181.333 382.499 164.105 321.553 164.105 321.553",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.149 369.286C189.387 369.942 188.66 370.693 188.017 371.564",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.945 364.97C202.945 364.97 197.751 364.791 192.926 367.39",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.108 367.999C198.108 367.999 191.281 370.288 189.864 375.082",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.578 486.861C159.578 486.861 158.184 437.136 145.662 404.642C133.14 372.148 125.718 367.963 120.619 369.358C115.519 370.753 108.097 379.577 103.45 373.531C98.8158 367.498 91.8579 350.78 94.6339 335.922C97.4218 321.064 102.986 318.286 105.762 314.565C108.55 310.857 93.7046 319.669 87.2114 329.423C80.7182 339.177 80.7182 362.847 84.4235 387.459C88.1288 412.059 97.4099 481.757 100.662 484.536C103.915 487.326 111.79 487.326 111.79 487.326H154.467L159.566 486.861H159.578Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.01 389.391H281.996V394.161H391.01V389.391Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.01 389.391H338.207V394.161H391.01V389.391Z",
    fill: "#B2B2B2",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.201 346.749H353.397L338.207 389.379H391.01L406.201 346.749Z",
    fill: "#D9D9D9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.562 520.571H350.812C349.108 520.571 347.726 519.188 347.726 517.483V397.094H354.636V517.483C354.636 519.188 353.254 520.571 351.55 520.571H351.562Z",
    fill: "#525252",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.12 520.571H363.369C361.665 520.571 360.283 519.188 360.283 517.483V397.094H367.194V517.483C367.194 519.188 365.812 520.571 364.108 520.571H364.12Z",
    fill: "#525252",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.317 520.571H265.566C263.862 520.571 262.48 519.188 262.48 517.483V397.094H269.39V517.483C269.39 519.188 268.008 520.571 266.305 520.571H266.317Z",
    fill: "#525252",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.44 520.571H437.689C435.986 520.571 434.604 519.188 434.604 517.483V397.094H441.514V517.483C441.514 519.188 440.132 520.571 438.428 520.571H438.44Z",
    fill: "#525252",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.438 399.92H448.031V394.292H254.438V399.92Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.438 459.578H448.031V453.95H254.438V459.578Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.517 448.214H288.965V453.854H339.517V448.214Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.517 448.214H316.809V453.854H339.517V448.214Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.268 448.214H365.716V453.854H416.268V448.214Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.268 448.214H393.56V453.854H416.268V448.214Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.335 442.311H284.783V447.952H335.335V442.311Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.335 442.311H312.627V447.952H335.335V442.311Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0642 520.571H542.903",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_393_551"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 560,
    height: 528,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgConfirmationImage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/confirmationImage.7800735bcf8fad7088130af9865224e1.svg";